<template>
    <b-container fluid>
        <div>
            <b-row>
                <b-col cols="12" class="py-2">
                    <label for="title">Nombre</label>
                    <app-form-input
                        type="text"
                        size="sm"
                        id="name"
                        v-model="performanceEvaluation.name"
                        required
                        @input="$v.performanceEvaluation.name.$touch()"
                        :hasError="$v.performanceEvaluation.name.$error"
                    ></app-form-input>
                </b-col>
            </b-row>
            <b-row>
                <b-col cols="12">
                    <app-form-input
                        label="Periodo de inicio"
                        type="date"
                        v-model="performanceEvaluation.initialQualificationPeriod"
                        required
                        @input="$v.performanceEvaluation.initialQualificationPeriod.$touch()"
                        :hasError="$v.performanceEvaluation.initialQualificationPeriod.$error"
                    ></app-form-input>
                </b-col>
            </b-row>
            <b-row>
                <b-col cols="12">
                    <app-form-input
                        label="Periodo final"
                        type="date"
                        v-model="performanceEvaluation.finalQualificationPeriod"
                        required
                        @input="$v.performanceEvaluation.finalQualificationPeriod.$touch()"
                        :hasError="$v.performanceEvaluation.finalQualificationPeriod.$error"
                    ></app-form-input>
                </b-col>
            </b-row>
            <b-row>
                <b-col cols="12">
                    <app-form-input
                        label="Fecha máxima de calificación"
                        type="date"
                        id="max-evaluation-date"
                        v-model="performanceEvaluation.maxEvaluationDate"
                        class="mb-2"
                        required
                        @input="$v.performanceEvaluation.maxEvaluationDate.$touch()"
                        :hasError="$v.performanceEvaluation.maxEvaluationDate.$error"
                    ></app-form-input>
                </b-col>
            </b-row>
            <b-row>
                <b-col cols="12">
                    <app-form-input
                        label="Fecha máxima de presentación de plan de acción"
                        type="date"
                        v-model="performanceEvaluation.maxActionsPlanDate"
                        class="mb-2"
                        required
                        @input="$v.performanceEvaluation.maxActionsPlanDate.$touch()"
                        :hasError="$v.performanceEvaluation.maxActionsPlanDate.$error"
                    ></app-form-input>
                </b-col>
            </b-row>
            <b-row>
                <b-col cols="12">
                    <app-form-input
                        label="Fecha de cierre"
                        type="date"
                        v-model="performanceEvaluation.deadline"
                        class="mb-2"
                        required
                        @input="$v.performanceEvaluation.deadline.$touch()"
                        :hasError="$v.performanceEvaluation.deadline.$error"
                    ></app-form-input>
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <label for="textarea">Notas</label>
                    <b-form-textarea
                        id="textarea"
                        v-model="performanceEvaluation.notes"
                        placeholder="Ingrese alguna nota..."
                        rows="3"
                        max-rows="6"
                    ></b-form-textarea>
                </b-col>
            </b-row>
        </div>
    </b-container>
</template>
<script>
import { required } from 'vuelidate/lib/validators'
export default {
    data: () => ({
        performanceEvaluation: {
            name: '',
            initialQualificationPeriod: '',
            finalQualificationPeriod: '',
            maxEvaluationDate: '',
            maxActionsPlanDate: '',
            notes: '',
            deadline: '',
            flagAdministrative: false
        },
        editing: false,
        current: '',
    }),
    validations: {
        performanceEvaluation: {
            name: { required },
            initialQualificationPeriod: { required },
            finalQualificationPeriod: {required},
            maxEvaluationDate: {required},
            maxActionsPlanDate: {required},
            deadline: {required}
        },
    },
    methods: {
        fill(evaluation) {
            this.current = evaluation
            this.editing = true
            this.performanceEvaluation.name = evaluation.name
            this.performanceEvaluation.initialQualificationPeriod = evaluation.initial_qualification_period
            this.performanceEvaluation.finalQualificationPeriod = evaluation.final_qualification_period
            this.performanceEvaluation.maxEvaluationDate = evaluation.max_evaluation_date
            this.performanceEvaluation.maxActionsPlanDate = evaluation.max_actions_plan_date
            this.performanceEvaluation.notes = evaluation.notes
            this.performanceEvaluation.deadline = evaluation.deadline
        },

        reset() {
            Object.keys(this.performanceEvaluation).map(
                key => (this.performanceEvaluation[key] = '')
            )
            this.editing = false
            this.initialPeriod = ''
            this.finalPeriod = ''
            this.maxEvaluation = ''
            this.maxAction = ''
        },
        async savePerformanceEvaluation(flagAdministrative) {
            this.performanceEvaluation.flagAdministrative = flagAdministrative
            this.$v.$touch()
            if (this.$v.$invalid) {
                return toastr.error(
                    'Por favor ingrese todos los campos obligatorios (*)'
                )
            }
            const { data } = !this.editing
                ? await repo.post('performance-evaluations', {
                    ...this.performanceEvaluation,
                })
                : await repo.put(`performance-evaluations/${this.current.id}`, {
                    ...this.performanceEvaluation,
                })

            if (data.status) {
                this.reset()
                this.$emit('saved', data)
            } else {
                toastr.error(data.msg)
            }
        },
    },
}
</script>
